export const APP_LOAD_NEW_SEND_CONTRACT_APPROVES = 'APP_LOAD_NEW_SEND_CONTRACT_APPROVES'
export const APP_SEND_CONTRACT_APPROVE_ALERT_CLOSE = 'APP_SEND_CONTRACT_APPROVE_ALERT_CLOSE'
export const APP_LOAD_USE_BRANCHES = 'APP_LOAD_USE_BRANCHES'